module.exports = __webpack_public_path__ + "img/scene4-4.4f01b6e8.png";